export enum SidePanelDirection {
  RIGHT_TO_LEFT = 'right-to-left',
  LEFT_TO_RIGHT = 'left-to-right',
}
